import { render, staticRenderFns } from "./ProductMiniCarouselItem.vue?vue&type=template&id=0ca52d36"
import script from "./ProductMiniCarouselItem.vue?vue&type=script&lang=js"
export * from "./ProductMiniCarouselItem.vue?vue&type=script&lang=js"
import style0 from "./ProductMiniCarouselItem.vue?vue&type=style&index=0&id=0ca52d36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports